export default __webpack_public_path__ + "static/media/Msmarkita.b0a9fcb9.jpeg";